import type { InsertPoentialHighQuality } from '@hvf/contracts'
import { user } from '@stateApp' // Assuming 'user' is exported from your stateApp barrel
import { createQuery, useMutation } from '@tanstack/solid-query'
import {
	confirmPotentialHighQualityRpc,
	createPotentialHighQualityPost,
	handleGetPotentialHighQuality,
	rejectPotentialHighQualityRpc,
	scorePotentialHighQualityRpc,
} from './resource'

export function usePotentialHighQuality() {
	const createPhqMutation = useMutation(() => ({
		mutationFn: (data: InsertPoentialHighQuality) =>
			createPotentialHighQualityPost(data),
	}))

	const confirmPhqMutation = useMutation(() => ({
		mutationFn: (setupId: string) => confirmPotentialHighQualityRpc(setupId),
	}))

	const rejectPhqMutation = useMutation(() => ({
		mutationFn: (setupId: string) => rejectPotentialHighQualityRpc(setupId),
	}))

	const scorePhqMutation = useMutation(() => ({
		mutationFn: ({ setupId, score }: { setupId: string; score: number }) =>
			scorePotentialHighQualityRpc(setupId, score),
	}))

	// NEW: Manage the fetching state of Potential High Quality setups
	const potentialHighQualityQuery = createQuery(() => ({
		queryKey: ['potentialHighQuality', user()?.user.id],
		queryFn: () => handleGetPotentialHighQuality(user()?.user.id as string),
		enabled: !!user()?.user.id,
	}))

	return {
		createPhqMutation,
		confirmPhqMutation,
		rejectPhqMutation,
		scorePhqMutation,
		potentialHighQualityQuery,
	}
}
